import { gql } from "@apollo/client";

export const DeleteInstalledBaseNode = gql`
    mutation DeleteInstalledBaseNode(
        $id: ID!
        $deleteSubNodes: Boolean
        $targetParentInstalledBaseNodeId: ID
    ) {
        deleteInstalledBaseNode(
            id: $id
            deleteSubNodes: $deleteSubNodes
            targetParentInstalledBaseNodeId: $targetParentInstalledBaseNodeId
        ) {
            success
            message
        }
    }
`;